<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="row">
            <div class="col-12">
                <div class="page_action">
                    <div class="tw-w-full text-right">
                        <button type="button" class="btn btn-sm btn-dark" data-toggle="modal" data-target="#addProduct">
                            <i class="fa fa-plus"></i>
                            เพิ่มสินค้า
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-fixed">
            <table class="table table-hover mt-3 mb-0 c_list">
                <thead>
                    <tr>
                        <th scope="col" class="tw-w-1/12">รูปภาพ</th>
                        <th scope="col" class="tw-w-2/12">ชื่อสินค้า</th>
                        <th scope="col" class="tw-w-2/12 text-right">ราคา ({{ currency ? currency.name : '' }})</th>
                        <th scope="col" class="text-right">สต็อกคงเหลือ</th>
                        <th scope="col" class="text-right">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="salePageProductData.length === 0">
                        <td class="text-center" colspan="5">
                            <span class="tw-cursor-pointer" data-toggle="modal" data-target="#addProduct">
                                ไม่พบสินค้า คลิกเพื่อเพิ่มสินค้า
                            </span>
                        </td>
                    </tr>
                    <tr class="tw-w-full tw-cursor-pointer" v-for="(item, index) in salePageProductData" :key="index"
                        @click="openProductDetail(item)">
                        <td>
                            <img class="table-image" :src="item.image_url" />
                        </td>
                        <td style="white-space: normal;">
                            <div class="tw-ellipsis">
                                {{ item.name }}
                            </div>
                        </td>
                        <td class="text-right">
                            {{ Number(item.price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                        </td>
                        <td class="text-right">{{ item.stock_balance }}</td>
                        <td class="text-right">
                            <button v-on:click.stop="confirmDelete(item.id)" type="button" data-type="confirm"
                                class="btn btn-sm btn-danger js-sweetalert" title="Delete">
                                <i class="fa fa-trash-o"> ลบ</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal" id="addProduct" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="tw-font-bold">
                            เพิ่มสินค้า Sale Page
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onClose">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <!-- show modal lists -->
                    <div class="modal-body" v-show="showProductLists">
                        <div class="table-responsive">
                            <table class="table table_modal table-hover mt-3 mb-0 c_list">
                                <thead>
                                    <tr>
                                        <th class="">รูปภาพ</th>
                                        <th class="tw-w-3/12">ชื่อสินค้า</th>
                                        <th class="tw-w-40">รายละเอียดสินค้า</th>
                                        <th class="text-right">ราคา ({{ currency ? currency.name : '' }})</th>
                                        <th class="text-right">สต็อกคงเหลือ</th>
                                        <th class="text-right">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="productData.length === 0">
                                        <td class="text-center" colspan="6">
                                            <a
                                                @click="showAddNewProduct = !showAddNewProduct, showProductLists = !showProductLists">
                                                <span class="tw-cursor-pointer tw-text-blue-500">
                                                    ไม่พบสินค้า
                                                    คลิกเพื่อเพิ่มสินค้า
                                                </span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-for="(item, index) in productData" :key="index">
                                        <td>
                                            <img class="table-image" :src="item.image_url" />
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td class="tw-w-40">
                                            <div class="text-ellipsis tw-w-40">
                                                {{ removeTag(item.description) }}
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            {{ Number(item.price).toLocaleString(undefined, { minimumFractionDigits: 2 })
                                            }}
                                        </td>
                                        <td class="text-center">{{ item.stock_balance }}</td>
                                        <td class="text-right">
                                            <button @click="addProductSalepage(item.id)" type="button" data-type="confirm"
                                                class="btn btn-sm btn-dark" title="Add">
                                                <i class="fa fa-plus"></i>
                                                เพิ่มสินค้า
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="productData.length">
                                        <td class="text-center" colspan="6">
                                            <a
                                                @click="showAddNewProduct = !showAddNewProduct, showProductLists = !showProductLists">
                                                <span class="tw-cursor-pointer tw-text-blue-500">
                                                    คลิกเพื่อเพิ่มสินค้า
                                                </span>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- add new -->
                    <div v-show="showAddNewProduct">
                        <div class="card">
                            <div class="tab-content">
                                <div class="tab-pane active" id="Product">
                                    <form @submit.prevent="handleSubmit()">
                                        <div class="body">
                                            <div class="media">
                                                <div class="media-left m-r-20" v-if="imageSrc">
                                                    <img :src="imageSrc" class="user-photo media-object" alt="User" />
                                                </div>
                                                <div class="media-body">
                                                    <label>เพิ่มรูปภาพสินค้า</label>
                                                    <div class="tw-text-xs tw-text-gray-500 col-12 mb-2 p-0">
                                                        <span>Recommended : 1920x1080 pixels,
                                                            1280x720 pixels, 1080x1080
                                                            pixels
                                                        </span>
                                                    </div>
                                                    <button type="button" class="btn btn-default" id="btn-upload-photo"
                                                        @click="uploadImage">
                                                        อัพโหลด
                                                    </button>
                                                    <input type="file" id="filePhoto" @change="onFileChange"
                                                        class="sr-only" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="body">
                                            <div class="row clearfix">
                                                <div class="col-lg-6 col-md-12">
                                                    <div class="form-group">
                                                        <label class="tw-ml-2">
                                                            ชื่อสินค้า
                                                        </label>
                                                        <input type="text" class="form-control" placeholder="ชื่อสินค้า"
                                                            v-model="form.name" required />
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-6">
                                                    <div class="form-group">
                                                        <label class="tw-ml-2">ราคาขาย</label>
                                                        <input type="number" step="0.01" class="form-control"
                                                            placeholder="ราคาขาย" v-model="form.price" required />
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-6">
                                                    <div class="form-group">
                                                        <label class="tw-ml-2">ราคาปกติ</label>
                                                        <input type="number" step="0.01" class="form-control"
                                                            placeholder="ราคาปกติ" v-model="form.price_full"
                                                            :min="form.price" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-md-12">
                                                    <div class="form-group">
                                                        <label class="tw-ml-2">รายละเอียด</label>
                                                        <count-character :text="form.description"
                                                            :maxText="200"></count-character>
                                                        <trumbowyg
                                                            v-model="form.description"
                                                            :config="config"
                                                            svgPath="/vendor/trumbowyg/dist/ui/icons.svg"
                                                        ></trumbowyg>
                                                    </div>
                                                    <div class="mt-2">
                                                        <label class="tw-ml-2">เลือกหมวดหมู่</label>
                                                        <Select2 
                                                            v-model="form.categories"
                                                            :options="categories" 
                                                            :settings="{ width: '100%', multiple: true }" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="body">
                                            <div class="tw-w-full text-right">
                                                <button class="btn btn-sm btn-success">
                                                    บันทึก
                                                </button>
                                                <button type="button" class="btn btn-sm btn-default tw-ml-1"
                                                    @click="showAddNewProduct = false, showProductLists = true">
                                                    ย้อนกลับ
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Product Detail -->
        <product-detail-component 
            :product="productDetail" 
            :isOpen="productDetailOpen" 
            :shop="shop" 
            :currency="currency"
            @closeModal="closeProductDetail" 
            @onUpdate="onUpdate"
        />
    </div>
</template>
<script>
import Select2 from "v-select2-component";
import configTextEditor from "../salepages/_config_texteditor.js";

export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        salepageId: {
            required: true,
            type: Number
        },
    },
    components: { Select2 },
    data() {
        return {
            loading: false,
            status: {
                addProduct: false
            },
            salePageProductData: [],
            productData: [],
            categories: [],

            imageSrc: "",
            image: null,
            imageDir: "/product",
            form: {},
            showProductLists: true,
            showAddNewProduct: false,

            currency: null,

            productDetailOpen: false,
            productDetail: null,

            config: configTextEditor
        };
    },
    mounted() {
        this.getData();
        this.getCurrency();
        this.getCategory();
    },
    methods: {
        handleSubmit() {
            this.loading = true;
            this.store();
        },
        async store() {
            this.loading = true;
            if (this.image) {
                let formData = new FormData();
                formData.append("name", this.form.name);
                formData.append("price", this.form.price);
                formData.append("price_full", this.form.price_full);
                formData.append("description", this.form.description);
                formData.append("image", this.image);
                formData.append("categories", this.form.categories);

                await axios
                    .post(`/backend/s/${this.shop}/products`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        this.loading = false;

                        this.getData();

                        this.form = {};
                        this.image = null;
                        this.imageSrc = "";
                        this.showProductLists = true;
                        this.showAddNewProduct = false;
                    })
                    .catch(err => {
                        this.messageAlert(
                            "error",
                            "Sorry",
                            "กรุณาใส่ข้อมูลให้ครบถ้วน"
                        );
                    });
            } else {
                this.messageAlert("error", "Sorry", "กรุณาใส่ข้อมูลให้ครบถ้วน");
                this.loading = false;
            }
        },
        async storeImage() {
            let formData = new FormData();
            formData.append("image", this.image ? this.image : "");
            formData.append("imageDir", this.imageDir);

            await axios
                .post(`/ajax/s/${this.shop}/upload-image`, formData)
                .then(res => {
                    this.form.image = res.data.imageUrl;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "เกิดข้อผิดพลาด",
                        "กรุณาลองใหม่อีกครั้ง"
                    );
                });
        },
        uploadImage() {
            document.getElementById("filePhoto").click();
        },
        async onFileChange(e) {
            let files = await e.target.files || e.dataTransfer.files;

            if (!files.length) {
                return;
            }

            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                );
            } else {
                this.image = files[0];
                this.previewImage(files[0]);
                document.getElementById("filePhoto").value = await "";
            }
        },
        previewImage(file) {
            this.imageSrc = URL.createObjectURL(file);
        },
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบสินค้าใช่ไหม?",
                text: "เมื่อกดยืนยัน สินค้าจะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deleteProductSalepage(id);
                }
            });
        },
        async addProductSalepage(id) {
            this.loading = true;
            const form = {
                productId: id
            };
            const url = `/ajax/s/${this.shop}/products/manage-salepage/${this.salepageId}`;
            await axios
                .post(url, form)
                .then(res => {
                    this.getData();
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        err.response.data.message
                    );
                });
        },
        addNewProduct() {
            this.showAddNewProduct = true
        },
        async onUpdate() {
            await this.getData()
                .then(() => {
                    this.productDetail = this.salePageProductData.find(product => {
                        return product.id == this.productDetail.id
                    })
                });
        },
        async deleteProductSalepage(id) {
            const url = `/ajax/s/${this.shop}/products/manage-salepage/${this.salepageId}/${id}`;
            await axios
                .delete(url)
                .then(res => {
                    this.getData();
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        err.response.data.message
                    );
                });
        },
        async getData() {
            await axios
                .get(
                    `/ajax/s/${this.shop}/products/manage-salepage/${this.salepageId}`
                )
                .then(res => {
                    this.salePageProductData = res.data.productSalePage;
                    this.productData = res.data.product;
                });
        },
        async getCurrency() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currency`)
                .then(res => {
                    this.currency = res.data.currency;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        async getCategory() {
            this.loading = true;
            await axios
                .get(`/ajax/s/${this.shop}/categories`)
                .then(res => {
                    res.data.categories.forEach(category => {
                        this.categories.push(category.title);
                    })
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        removeTag(str) {
            if ((str === null) || (str === '')) {
                return '';
            }
            else {
                str = str.toString();
            }
            str = str.replace(/(<([^>]+)>)/ig, '');
            str = str.replace(/&[^;]+;/g, '');
            
            return str;
        },
        openProductDetail(product) {
            this.productDetail = product;
            this.productDetailOpen = true;
        },
        closeProductDetail() {
            this.productDetailOpen = false;
            this.productDetail = null;
        },
        onClose() {
            this.showProductLists = true;
            this.showAddNewProduct = false;

            this.form = {};
            this.imageSrc = "";
            this.image = null;
        }
    }
};
</script>
<style lang="scss" scoped>
.table-image {
    width: 100%;
    // max-width: 200px;
}

.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.table_modal thead th {
    border-top: none !important;
}

.media {
    @media (min-width: 0px) and (max-width: 992px) {
        width: 100%;
        flex-flow: column;
        flex-direction: column-reverse;
    }
}
.media-left {
    img {
        width: 100%;
        max-width: 200px;
    }

    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
    }
}
</style>
